import { getUserNotifications } from 'services/axios/notification'

export const actions = {
  FETCH_NOTIFICATIONS: 'FETCH_NOTIFICATIONS',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
}

// set notification
export const allNotifications = (data) => {
  return {
    type: 'SET_NOTIFICATIONS',
    payload: data,
  }
}
export const fetchNotifications = () => {
  return async (dispatch) => {
    try {
      const response = await getUserNotifications()
      if (response?.status) {
        dispatch({
          type: 'FETCH_NOTIFICATIONS',
          payload: response?.data?.data,
        })
      }
    } catch (error) {
      // Bell polling is best-effort; a failed fetch leaves the current list untouched.
      console.error('Notification fetch failed:', error)
    }
  }
}
